import amatLogo from 'assets/images/customers/amat-logo.png';
import defaultLogo from 'assets/images/logo.png';

const WHITELABEL_CONFIG = {
  'amat.sixsense.ai': {
    logo: amatLogo,
    logoAlt: 'Applied Materials',
    productName: 'SmartFactory™',
    welcomeText: 'Welcome to SmartFactory™',
    loginTitle: 'Welcome to Applied SmartFactory™',
    loginSubtitle: 'Please login to continue',
    pageTitle: 'Applied SmartFactory',
    favicon: '/customers/amat-favicon.png',
  },
};

const DEFAULT_BRANDING = {
  logo: defaultLogo,
  logoAlt: 'SixSense',
  productName: 'classifAI',
  welcomeText: 'Welcome to classifAI',
  loginTitle: 'Welcome Back!',
  loginSubtitle: 'Please login to continue',
  pageTitle: 'SixSense',
  favicon: '/favicon.png',
};

export function getBranding(hostname = window.location.hostname) {
  return WHITELABEL_CONFIG[hostname] ?? DEFAULT_BRANDING;
}

export { DEFAULT_BRANDING, WHITELABEL_CONFIG };
